import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { InformationPageContent } from 'src/app/intefaces/information-page-content.interface';
import { InformationPageService } from 'src/app/services/informationPage.service';
import { BrowserStorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-payments-methods',
  templateUrl: './payments-methods.component.html',
  styleUrls: ['./payments-methods.component.scss']
})
export class PaymentsMethodsComponent implements OnInit {

  paymentsMethods: InformationPageContent = { content: '' };

  constructor(
    private pageService: InformationPageService,
    private translate: TranslateService,
    private browserStorageService: BrowserStorageService, private title: Title) { }

  ngOnInit(): void {
    this.initContent(null);
    this.translate.onLangChange.subscribe(
      lang => { this.initContent(lang.lang); }
    );
    this.translate.get('title_payment_methods').subscribe({
      next: (title) => {
        this.title.setTitle(title);
      }
    });
  }

  private initContent(lang: string): void {
    if (lang == null) {
      lang = this.browserStorageService.get("_lang");
      if (lang == null || lang == '') {
        lang = 'pl';
      }
    }
    this.pageService.getInformationPage(this.pageService.PAGES.payments_methods, lang).subscribe((response: any) => {
      this.paymentsMethods.content = response.data.page[Object.keys(response.data.page)[0]];
    });
  }

}
